<template>
  <div>
    <b-row class="mb-4 mt-0" align-h="end">
      <b-col md="3">
        <b-button size="sm" block v-b-modal.modal-1 variant="primary" class="mb-0">Nuevo reporte de compras</b-button>
      </b-col>
    </b-row>

    <b-modal id="modal-1" size="xl" scrollable 
        @ok="onSubmit" 
        @close="cleanModal"
        @cancel="cleanModal"
        title="Nuevo reporte de compras">
        <!-- cancel-title="Cancelar" -->
        <!-- :ok-title="continueButton" -->
        <b-row>
            <b-col md=3 class="apply-for-min-height">
                <b-form @submit="onSubmit">

                    <b-form-group label="Inicio del reporte:" 
                        label-for="inicio-reporte"
                        description="A partir de que fecha se generará el reporte">
                        <b-form-datepicker id="inicio-reporte" v-model="form.inicio" required></b-form-datepicker>
                    </b-form-group>

                    <b-form-group label="Fin del reporte:" label-for="fin-reporte" description="Fecha de cierre del reporte">
                        <b-form-datepicker id="fin-reporte" v-model="form.fin" required></b-form-datepicker>
                    </b-form-group>

                </b-form>
            </b-col>
            <b-col no-flush md=9 class="p-0 pr-3" v-if="articulos.length">
                  <b-tabs>
                    <b-tab title="Resumen" active>
                        <b-table class="m-0" sticky-header sticky-header="36.5em" striped response borderless :items="articulos" :fields="articulosFields"></b-table>
                    </b-tab>
                    <b-tab title="Pedidos con bloqueo de estatus">
                        <b-table class="m-0" sticky-header sticky-header="36.5em" striped response borderless :items="pedidos" :fields="pedidosFields"></b-table>
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
        <template v-slot:modal-footer="{ ok, cancel, hide }">
            <b-button size="sm" variant="" @click="cancel()">
                Cancelar
            </b-button>
            <b-button size="sm" variant="primary" @click="ok()">
                {{continueButton}}
            </b-button>
            <!-- Button with custom close trigger value -->
            <b-button size="sm" variant="outline-danger" @click="store()" v-if="articulos.length">
                Aplicar
            </b-button>
        </template>
    </b-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import _ from 'lodash'

  export default {
    data() {
      return {
        show: true,
        pedidos: [],
        articulos: [],
        pedidosFields: [
            {
                key: 'folio',
                label: 'Folio',
                sortable: true 
            },
            {
                key: 'cliente',
                label: 'cliente',
                sortable: true 
            },
            {
                key: 'fechaEntrega',
                label: 'Fecha de entrega',
                sortable: true 
            }
        ],
        articulosFields: [
            {
                key: 'elemento',
                label: 'Elemento',
                sortable: true 
            },
            {
                key: 'marca',
                label: 'Marca',
                sortable: true 
            },
            {
                key: 'presentacion',
                label: 'Presentacion',
                sortable: true 
            },
            {
                key: 'unidadmedicion',
                label: 'Unidad',
                sortable: true 
            },
            {
                key: 'Cantidad',
                label: 'Cantidad',
                sortable: true 
            }
        ],
        form: {
          inicio: '',
          fin: ''
        }
      }
    },
    computed: {
        continueButton() {
            return (this.articulos.length == 0) ? 'Consulta previa' : 'Actualizar consulta previa'
        }
    },
    methods: {
      cleanModal() {
        //   alert('clenaing')
        this.form = {
          inicio: '',
          fin: ''
        }
        this.pedidos = []
        this.articulos = []
      },
      onSubmit(evt) {
        evt.preventDefault()
        axios.post('compras/query', this.form).then(r => {
          this.pedidos      = (r.data.pedidos) ? r.data.pedidos: []
          this.articulos    = (r.data.articulos) ? r.data.articulos: []
        })
      },
      store() {
        axios.post('compras/process', _.merge(this.form, {pedidos: this.pedidos, articulos: this.articulos})).then(r => {
            if(r.status){
                this.$bvModal.hide('modal-1')
                this.cleanModal()
            }
        })
      }
    },
    watch: {
        'form.inicio'(){
            this.pedidos = []
            this.articulos = []
        },
        'form.fin'(){
            this.pedidos = []
            this.articulos = []
        }
    }
  }

</script>

<style>
  .apply-for-min-height {
    min-height: 40em;
  }

</style>
